var _ = require('underscore');

import dbstorage from "./dbstorage.js";
import f from './functions.js'


var Sync = function (core){
    var self = this
    var running = null
    var controller = null
    var date = null
    var syncdata = null
    var storage = null
    var version = 1
    var resyncTimeout = null

    var getstorage = function (p) {
7
		if (!storage) {
			return dbstorage('sync', version, 'inf').then(_storage => {
				storage = _storage

				return Promise.resolve(_storage)
			})
		}

		return Promise.resolve(storage)
	}

    

    var local = {
        get : function(running){
            if(!running) return Promise.reject()

            return getstorage().then(storage => {
                return running.id().then(id => {
                    return storage.get(id)
                })
            })
        },

        set : function(id, data){

            return getstorage().then((storage) => {

                var saveData = {...data}

                delete saveData.userinfo

                return storage.set(id, saveData)
                
            })

        }
    }

    var compose = function({data, nd}){

        date = nd

        if(!syncdata){
            syncdata = data
        }

        else{

            if (data.userinfo) {
                syncdata.userinfo || (syncdata.userinfo = {})
                syncdata.userinfo = {...syncdata.userinfo, ...data.userinfo}
            }

            if (data.features) {
                syncdata.features = data.features
            }

            if (data.chats){
                syncdata.chats || (syncdata.chats = [])

                _.each(data.chats, (s_chat) => {
                    var existChat = _.find(syncdata.chats, (chat) => {
                        return chat.uid == s_chat.uid
                    })

                    if(!existChat){
                        syncdata.chats.push(s_chat)
                    }
                    else{

                        //members

                        if(!existChat.members) existChat.members = []

                        _.each(s_chat.members, (s_member) => {
                            var existMember = _.findIndex(existChat.members, (member) => {
                                return member.relation == s_chat.relation
                            })

                            if (existMember == -1){
                                existChat.members.unshift(s_member)
                            }
                            else{
                                s_chat.members[existMember] = {...s_chat.members[existMember], ...s_member}
                            }
                        })

                        if(!existChat.events) existChat.events = []

                        //events

                        s_chat.events = _.sortBy(s_chat.events, (e) => {
                            return new Date(e.date)
                        })

                        _.each(s_chat.events, (s_event) => {
                            var existEvent = _.findIndex(existChat.events, (event) => {
                                return event.uid == s_event.uid
                            })

                            if (existEvent == -1){
                                existChat.events.unshift(s_event)
                            }
                            else{
                                s_chat.events[existEvent] = {...s_chat.events[existEvent], ...s_event}
                            }
                        })

                        /*existChat.events.events = _.sortBy(existChat.events.events, (e) => {
                            return new Date(e.date)
                        })*/

                        if(!existChat.read_markers) existChat.read_markers = {}

                        existChat.read_markers = {
                            ...existChat.read_markers,
                            ...s_chat.read_markers
                        }
                        
                    }
                })

               

            }

        }

        return syncdata
    }

    self.saveLocal = function(){
        running.id().then(id => {

            if(syncdata){

                console.log("SAVE LOCAL")

                return local.set(id, {
                    data : syncdata,
                    date : new Date()
                })
            }
            
        })
    }

    var process = function(){

        if(!running) return

        if(resyncTimeout){
            clearTimeout(resyncTimeout)
            resyncTimeout = null
        }
        

        controller = new AbortController()

        var nd = new Date()
        var uid = null
        var waserror = false

        return running.id().then(id => {

            uid = id

            return core.api.sync.request({date}, {controller})
        }).then((newsyncdata) => {

            compose({data : newsyncdata, nd : nd})

            core.emit('synk', {data : syncdata, id : uid, date : nd})
            core.emit('synk_changed', {data : newsyncdata, id : uid, date : nd})

            if(newsyncdata.userinfo) running.setUserInfo({userinfo : newsyncdata.userinfo})
            if(newsyncdata.features) running.setUserInfo({features : newsyncdata.features})
            
            //// change user info 

            return local.set(uid, {
                data : syncdata,
                date : nd
            })

        }).catch(e => {
            if(e != 'stopped'){
                waserror = e
            }
        }).finally(() => {

            resyncTimeout = setTimeout(() => {
                process()
            }, waserror ? 30000 : 300)
 
        })
    }

    var run = function(user){
        running = user
        process()
    }

    var stop = function(){

        if(resyncTimeout){
            clearTimeout(resyncTimeout)
            process()
        }
        else{
            if(controller && !controller.signal.dontabortable) controller.abort('stopped')
        }

        
    }

    var clear = function(){
        running = null
        date = null
        syncdata = null
        controller = null
    }

    self.resume = function(){
        stop();

        process()
    }

    

    self.stop = stop

    self.init = function(user){

        clear()

        local.get(user).then((stored) => {

            if(stored.data?.userinfo) delete stored.data.userinfo

            syncdata = stored.data
            
            date = new Date(stored.date)

            user.id().then(id => {
                core.emit('synk', {data : syncdata, id, date})
            })

        }).catch(e => {
            return Promise.resolve()
        }).finally(() => {
            run(user)
        })

        
    }

    self.destroy = function(){
        stop()
        clear()
    }


    return self
}


export default Sync
